class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');
        const autoShow = this.popup.getAttribute('data-auto-show') !== 'false';

        if (autoShow && this.getCookie('newsletter-popup') === ''){
            var popup = this.popup;

            setTimeout(function() {
                document.body.classList.add('newsletter-show');
            }, this.timeToShow);

            setTimeout(() => {
                document.body.classList.add('show-newsletter-image');
            }, this.timeToShow + 700)
        } else {
            // this.deleteCookie('newsletter-popup');
        }
        
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            () => this.setClosePopup(false)
        );

        this.querySelector('#ContactPopup').addEventListener(
            'submit',
            this.onFormSubmit.bind(this)
        );
    }

    onFormSubmit(event) {
        if (!document.body.classList.contains('newsletter-add-to-cart-gate')) {
            this.setClosePopup(true);
            return;
        }

        event.preventDefault();

        const form = event.target;
        const formData = new FormData(form);

        fetch(form.action || '/contact', {
            method: 'POST',
            body: formData
        })
        .then((response) => {
            this.setClosePopup(response.ok);
        })
        .catch(() => {
            this.setClosePopup(false);
        });
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup(subscribed = false) {
        const isGate = document.body.classList.contains('newsletter-add-to-cart-gate');

        if (subscribed === true) {
            this.setCookie('emailSubcribeModal', 'closed', this.expiresDate);
        }

        if (!isGate) {
            this.setCookie('newsletter-popup', 'closed', this.expiresDate);
        }

        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700);

        if (isGate && window.haloNewsletterGate) {
            if (subscribed === true) {
                window.haloNewsletterGate.complete();
            } else {
                window.haloNewsletterGate.cancel();
            }
        }
    }

    onBodyClickEvent(event){
        if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-newsletter-popup]').length === 0) && document.querySelector('body').classList.contains('newsletter-show')){
            this.setClosePopup(false);
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close(){
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);